import React from "react";

import { Alert } from "@components/General/Alert/alert.component";

type Props = {
    message: string;
    handleDelete?: () => void;
};

const ErrorMessage = ({ message, handleDelete }: Props) => (
    <Alert
        id="errorMessage"
        color="danger"
        isOpen={true}
        toggle={handleDelete ? () => handleDelete() : undefined}
    >
        {message}
    </Alert>
);

export default ErrorMessage;
